import Image from '@anm/components/image/Image';

import SliderArrowWrapper from './SliderArrowWrapper';
import { SliderArrowProps } from './types';

const SliderArrow = (props: SliderArrowProps) => (
  <SliderArrowWrapper {...props} className="slider-custom-arrow">
    <Image src="images/slider-arrow.svg" alt="slider arrow" />
  </SliderArrowWrapper>
);

export default SliderArrow;
